/*  Pass in an array of class names, or spread:
 * <div className={setClass(["a", isOk ? "ok" : "", someProp])} />
 * <div className={setClass('a', 'b', isOk && 'c')}
 */
const setClass = (...classes) => (Array.isArray(classes[0]) ? classes[0] : classes)
    .filter(Boolean)
    .map((v) => String(v).trim())
    .join(' ');
export default setClass;
